import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.p-toast-message {
	position: relative;
	overflow: hidden;
}

.toast-progress {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 3px;
	transform-origin: left;
	animation-name: toast-progress;
	animation-timing-function: linear;
	animation-fill-mode: forwards;
}

.toast-progress--hidden {
	display: none;
}

.toast-progress--info {
	background: ${dt('toast.colorScheme.light.root.info.color')};
}

.toast-progress--success {
	background: ${dt('toast.colorScheme.light.root.success.color')};
}

.toast-progress--warn {
	background: ${dt('toast.colorScheme.light.root.warn.color')};
}

.toast-progress--error {
	background: ${dt('toast.colorScheme.light.root.error.color')};
}

@keyframes toast-progress {
	from {
		transform: scaleX(1);
	}
	to {
		transform: scaleX(0);
	}
}
`;
